<template>
  <div style="background-color: #fafcff">
    <div class="center_tabbar">
      <ul>
        <li
          @click="handleTab(item, index)"
          :class="{ active: activeName == item.id }"
          v-for="(item, index) in fenleiData"
          :key="item.id"
        >
          <div style="text-align: center">
            <img
              v-if="activeName == item.id"
              style="width: 80px; height: 80px"
              :src="item.t_image"
              alt=""
            />
            <img
              v-if="activeName != item.id"
              style="width: 80px; height: 80px"
              :src="item.t_logo_main"
              alt=""
            />
            <p>{{ item.t_name }}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="contain">
      <!-- 商用产品 -->
      <div class="disn disb" v-if="erjifenleiData">
        <div class="center_neirong">
          <div class="left">
            <div
              class="enter"
              v-for="item in erjifenleiData"
              :key="item.id"
              @click="erjiclick(item)"
            >
              <div>{{ item.t_name }}</div>
              <img
                class="bg"
                style="width: 18px; height: 14px"
                src="@/assets/img/bg/right.png"
                alt=""
              />
            </div>
            <div class="img_box" style="width: 160px; height: 160px">
              <img :src="qrcode" alt="" style="width: 160px; height: 160px" />
            </div>
          </div>
          <div class="right">
            <div class="wuzi">
              <div
                class="goods"
                v-for="(item, index) in goodsList"
                :key="item.id"
              >
                <img
                  @click="tiaozhuan(item, index)"
                  :src="item.show_img"
                  alt=""
                />
                <p>{{ item.title }}</p>
              </div>
            </div>
            <div class="fenye" v-if="total != 0">
              <el-pagination
                :page-size="6"
                layout="pager"
                :total="total"
                :current-page="page"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
            <div v-else style="text-align: center; margin-bottom: 30px">
              暂无商品
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import store from "@/store/index.js";
export default {
  data() {
    return {
      activeName: "",
      total: 0,
      page: 1,
      fenleiData: [],
      erjifenleiData: [],
      goodsList: [],
      qrcode: "",
      imgList: [{ src: "@/assets/img/bg/yy.png" }],
      cid: "",
      rid: "",
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getData(this.cid, this.rid);
    },
    tiaozhuan(item, index) {
      console.log(item.id);
      this.$router.push(
        `/goodDetail?cid=${this.cid}&rid=${this.rid}&i=${index}&id=${item.id}`
      );
    },
    handleTab(item) {
      this.activeName = item.id;
      this.erjifenleiData = item.child;
      if (item.child[0]) {
        this.erjiclick(item.child[0]);
      }
      this.handleCurrentChange(1);
    },
    erjiclick(item) {
      this.getData(item.cid, item.id);
      this.handleCurrentChange(1);
    },
    getfenlei() {
      axios({
        url: this.base_url.base_url + "/index.php/index/index/cate_list",
        method: "get",
      })
        .then((res) => {
          this.fenleiData = res.data.data.cate_list;
          if (this.$route.query.id) {
            // 如果有id 判断
            this.fenleiData.forEach((v) => {
              if (v.id == this.$route.query.id) {
                this.activeName = v.id;
                this.erjifenleiData = v.child;
              }
            });
          } else {
            // 默认情况
            this.activeName = this.fenleiData[0].id;
            this.erjifenleiData = this.fenleiData[0].child;
          }
          const item = this.erjifenleiData[0];
          this.getData(item.cid, item.id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getData(cid, id) {
      this.cid = cid;
      this.rid = id;
      axios({
        url:
          this.base_url.base_url +
          `/index.php/index/index/goods_list?cid=${cid}&rid=` +
          id,
        method: "get",
        params: {
          page: this.page,
          limit: 6,
        },
      })
        .then((res) => {
          this.goodsList = res.data.data.goods_data;
          this.total = res.data.data.goods_count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQRCode() {
      axios({
        url: this.base_url.base_url + "/index.php/index/index/web_conf",
        method: "get",
      })
        .then((res) => {
          this.qrcode = res.data.data.web_company_goods_qrcode;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getfenlei();
    this.getQRCode();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.center_tabbar ul {
  display: flex;
  justify-content: center;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 183px;
    background-image: url("@/assets/img/bg/goodsTab.png");
    cursor: pointer;

    &.active {
      color: #333;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);

      p {
        color: #333 !important;
      }
    }

    p {
      width: 75px;
      height: 18px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }

    :hover {
      p {
        color: #333;
      }
    }
  }
}

.contain {
  background-color: #fafcff;
  padding-top: 61px;
}

.disn {
  display: none;

  &.disb {
    display: block;
  }

  .center_neirong {
    display: flex;
    justify-content: space-between;
    width: 1306px;
    margin: 30px auto;

    .left {
      background-color: #fff;
      width: 330px;
      height: 920px;
      position: relative;

      .enter {
        margin: 0 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #6e6b6aff;
        height: 80px;
        cursor: pointer;

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
      }

      .enter:hover {
        color: #234ce2;
        background: url("@/assets/img/bg/rightActive.png") no-repeat center
          right;
        background-size: 6.5%;

        .bg {
          display: none;
        }
      }

      .img_box {
        position: absolute;
        left: 50%;
        bottom: 50px;
        transform: translate(-50%);
      }
    }

    .right {
      .wuzi {
        width: 956px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .goods {
          width: 305px;
          height: 450px;
          background-color: #fff;
          text-align: center;
          // padding: 10px;
          margin-bottom: 20px;
          cursor: pointer;

          img {
            width: 305px;
            height: 450px;
            object-fit: contain;
          }

          p {
            transform: translateY(-50px);
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
          }

          :hover {
            color: #234ce2;
          }
        }
      }

      .fenye {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-bottom: 50px;
      }
    }
  }
}

.block {
  margin-top: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-pagination {
  font-weight: 400;
}

.block span {
  font-size: 12px;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
}

.el-pagination .btn-prev .el-icon {
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  font-weight: 400 !important;
  padding-right: 20px;
}

.el-pagination .btn-prev .el-icon:hover {
  color: #234ce2 !important;
}

.el-pagination .btn-next .el-icon {
  font-size: 12px;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  font-weight: 400 !important;
  padding-left: 20px;
}

.el-pagination .btn-next .el-icon:hover {
  color: #234ce2 !important;
}

::v-deep {
  .el-pager {
    .number {
      width: 35px;
      height: 35px;
      border: 1px solid #000 !important;
      border-radius: 50%;
      line-height: 32px;
      margin-right: 10px;
      cursor: pointer;

      &.active {
        background-color: #234ce2;
        color: #fff;
      }
    }
  }
}

.el-pager li {
  font-weight: 400;
  width: 35.5px !important;
  height: 35.5px !important;
  line-height: 35px !important;
  text-align: center !important;
  border: 1px solid #000 !important;
}

.el-pager li.active {
  /* width: 35.5px !important;
  height: 35.5px !important; */
  /* text-align: center !important;
  line-height:35px !important; */
  border-radius: 35px !important;
  border: 1px solid #234ce2 !important;
  color: #234ce2 !important;
}

.el-pager li:hover {
  color: #234ce2 !important;
}

.ra_1 {
  width: 39px;
  height: 39px;
  border: 1px solid #6e6b6a;
  border-radius: 50%;
  text-align: center;
  line-height: 39px;
  cursor: pointer;
}

.bian_blue {
  background: #234ce2;
  color: #fff;
  border-color: #234ce2;
}

/* .el-container.is-vertical {
    background: #f5f5f5FF !important;
} */
.footer {
  margin-top: 60px;
}
</style>
